import { storageHttpClient, ws } from 'shared/store/ws'

const storageBaseUrlKeys = {
    API: 'customApiUrl',
    STORAGE: 'customStorageUrl'
}

// set custom api url
const setCustomApiURL = (apiURL: string, isStorage?: boolean) => {
    const key = isStorage ? storageBaseUrlKeys.STORAGE : storageBaseUrlKeys.API

    window.localStorage.setItem(key, apiURL)
    if (isStorage) {
        storageHttpClient.defaults.baseURL = apiURL
    } else {
        ws.defaults.baseURL = apiURL
    }
}

// get custom api url
const getCustomApiURL = ({ isStorage = false }: { isStorage?: boolean }) => {
    const key = isStorage ? storageBaseUrlKeys.STORAGE : storageBaseUrlKeys.API

    return window.localStorage.getItem(key)
}

const hasChangedAPIURL = () => {
    const defaultAPIURL = process.env.REACT_APP_API_ENDPOINT
    const defaultStorageURL = process.env.REACT_APP_STORAGE
    return (
        getCustomApiURL({ isStorage: false }) !== defaultAPIURL ||
        getCustomApiURL({ isStorage: true }) !== defaultStorageURL
    )
}

export { setCustomApiURL, getCustomApiURL, hasChangedAPIURL }
